import SmartReplyComposeSIGSData from '../store/schema/SmartReplyComposeSIGSData';
import { SmartDocOption } from '../store/schema/SmartDocOption';
import SmartPillViewState from '../store/schema/SmartPillViewState';

export default function createSmartPillViewState(
    smartDocOption: SmartDocOption
): SmartPillViewState {
    const smartReplyComposeSIGSData: SmartReplyComposeSIGSData = {
        isSmartSuggestionsClicked: false,
        suggestionsClickedTime: null,
        clickIndex: -1,
    };
    return {
        smartReplyComposeSIGSData: smartReplyComposeSIGSData,
        smartDocOption: smartDocOption || SmartDocOption.None,
    };
}
